// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  matchId: __t.option(__t.u64()).name("match_id"),
  round: __t.u32(),
  level: __t.string(),
  event: __t.string(),
  message: __t.string(),
  data: __t.string(),
  createdAtMicros: __t.u64().name("created_at_micros"),
});
